module.exports = __webpack_public_path__ + "ecee89e69374dcba7eab5e6d5e03e581.svg";